import { useState } from "react";
import { Href } from "../../../constants";
import { Cities } from "../../../data/layout/Header";
import CitySelectMenu from "../../../components/commonComponents/CitySelectMenu";

const CityDropdown = () => {
  const [selectedCity, setSelectedCity] = useState("Amsterdam");

  return (
    <>
      <div className="select-dropdown">
        <a href={Href} className="select-button">
          {selectedCity}
        </a>
        <div className="mega-menu-1">
          <CitySelectMenu multiColumn={false} cityList={Cities} selectedCity={selectedCity} onSelectCity={(city) => setSelectedCity(city)} href={Href} />
        </div>
      </div>
    </>
  );
};

export default CityDropdown;